"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UPDATE_RESOURCES = exports.REQUEST_REJECTED = exports.REQUEST_PENDING = exports.REQUEST_IDLE = exports.REQUEST_FULFILLED = exports.DELETE_RESOURCES = void 0;
var UPDATE_RESOURCES = '@@redux-resource/UPDATE_RESOURCES';
exports.UPDATE_RESOURCES = UPDATE_RESOURCES;
var DELETE_RESOURCES = '@@redux-resource/DELETE_RESOURCES';
exports.DELETE_RESOURCES = DELETE_RESOURCES;
var REQUEST_IDLE = '@@redux-resource/REQUEST_IDLE';
exports.REQUEST_IDLE = REQUEST_IDLE;
var REQUEST_PENDING = '@@redux-resource/REQUEST_PENDING';
exports.REQUEST_PENDING = REQUEST_PENDING;
var REQUEST_FULFILLED = '@@redux-resource/REQUEST_FULFILLED';
exports.REQUEST_FULFILLED = REQUEST_FULFILLED;
var REQUEST_REJECTED = '@@redux-resource/REQUEST_REJECTED';
exports.REQUEST_REJECTED = REQUEST_REJECTED;
var actionTypes = {
  UPDATE_RESOURCES: UPDATE_RESOURCES,
  DELETE_RESOURCES: DELETE_RESOURCES,
  REQUEST_IDLE: REQUEST_IDLE,
  REQUEST_PENDING: REQUEST_PENDING,
  REQUEST_FULFILLED: REQUEST_FULFILLED,
  REQUEST_REJECTED: REQUEST_REJECTED
};
var _default = actionTypes;
exports.default = _default;